<template>
  <div class="vendor-definition-form">
    <div class="modal-body">
      <base-input
        v-model="formItems.order"
        inputType="number"
        labelText="Sıra No"
      />
      <BaseSelect
        v-model="formItems.DataGroup"
        @change="changeDataGroup"
        :selectedId="this.defaultSelected"
        id="dataGroup"
        :options="formItems.dataGroup"
        fieldLabel="Veri Grubu"
        placeholder="Veri Grubu Seç"
        :clearable="true"
      />
      <base-input
        v-model="formItems.newVendorName"
        inputType="text"
        labelText="Yeni İşlem Platformu"
      />
      <BaseSelect
        v-model="formItems.IntegrationType"
        @change="changeIntegrationType"
        :selectedId="this.defaultSelected"
        id="integrationType"
        :options="formItems.integrationType"
        fieldLabel="Entegrasyon Türü"
        placeholder="Entegrasyon Türü Seç"
        :clearable="true"
      />
    </div>
    <div class="modal-bottom">
      <base-button class="giveUp" @click="$modal.hide('modal')"
        >Vazgeç</base-button
      >
      <base-button @click="sendForm" class="add">Kaydet</base-button>
    </div>
  </div>
</template>
<script>
import { BaseSelect, BaseInput, BaseButton } from "@/components";

export default {
  name: "VendorDefinition",
  props: {
    InsertUpdateForm: {
      type: Function,
    },
  },
  data() {
    return {
      DataGroup: "",
      IntegrationType: "",
      defaultSelected: -1,
      formItems: {
        order: "",
        dataGroup: ["Veri Terminali", "Osmanlı Uygulamaları"],
        integrationType: ["API", "MAIL"],
        newVendorName: "",
      },
    };
  },
  components: {
    BaseSelect,
    BaseInput,
    BaseButton,
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    changeDataGroup(value) {},
    // eslint-disable-next-line no-unused-vars
    changeIntegrationType(value) {},
    sendForm() {
      this.InsertUpdateForm(this.formItems);
    },
  },
};
</script>
